import $ from 'jquery'

export default class debugCopyCode {
  constructor (element) {
    this.$element = $(element)
    this.copyData = this.$element.data('copyData')
    this.$element.on('click', this.handleClick.bind(this))
  }

  handleClick (event) {
    // console.log(this.copyData)
    event.preventDefault()
    if (window.navigator.clipboard) {
      window.navigator.clipboard.writeText(this.copyData)
    }
    $('body').focus()
  }
}
